exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-peque {\n\tpadding:0 5px 0 10px;\n\tmargin:4px 0 2px 0;\n\tfont-size:11px;\n}\n.row-media {\n\tpadding:0 5px 0 10px;\n\tmargin:4px 0 2px 0;\n\tfont-size:13px;\n}\n.abono {\n\tbackground-color:#98B8D8 !important;\n}\n.producto {\n\tbackground-color:#E09E41 !important;\n}\n", ""]);

// exports
